<template>
  <section id="interests" class="resume-section">
    <div class="resume-section-content">
      <h2 class="mb-5">{{ interestsTitle }}</h2>
        <p> {{ interests }}</p>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    interestsTitle() {
      return this.$t('sections.interests');
    },
    interests() {
      return this.$t('interests.interests');
    }
  }
};
</script>
